export default __webpack_public_path__ + "static/media/2x-square.05956d88.jpg";